import React from "react";
import { ErrorMessage } from "formik";
import { Col, Form } from "react-bootstrap";
import { getProductFieldName } from "../utils/utils";
import NumberInput from "../../../../Products/inputs/NumberInput";

interface DiscountRadioGroupProps {
    name: string;
    id: string;
    isDiscount: boolean;
    toggleRadioButton: () => void;
    index: number;
    disabled: boolean;
}

const DiscountRadioGroup: React.FC<DiscountRadioGroupProps> = ({
    name,
    id,
    isDiscount,
    toggleRadioButton,
    index,
    disabled,
}) => {
    return (
        <>
            <Col xs="auto" className="px-0 d-flex align-items-start">
                <div className="position-relative">
                    <Form.Check
                        type="radio"
                        name={`radio-discount-toggle-${index}`}
                        className="position-absolute top-50 start-0 translate-middle-y ms-6 z-1"
                        disabled={disabled}
                        checked={isDiscount}
                        onChange={toggleRadioButton}
                    />
                    <NumberInput
                        id={id}
                        name={name}
                        placeholder="0"
                        disabled={!isDiscount || disabled}
                        isRadioButton
                        icon="%"
                        maxLength={3}
                        validateImmediately
                    />
                </div>
            </Col>
            <ErrorMessage name={getProductFieldName(index, "discount")}>
                {(msg) => <div className="invalid-feedback d-block w-100">{msg}</div>}
            </ErrorMessage>
        </>
    );
};

export default DiscountRadioGroup;
